import "@babel/polyfill";
import "normalize.css";
import "./scss/style.scss";
import picturefill from "picturefill";

picturefill();

import spmenuInit from "./modules/spmenu";
spmenuInit();

import accordionInit from "./modules/accordion";
accordionInit();

import bgsetInit from "./modules/bgset";
bgsetInit();

